// @ts-nocheck --> Important to remove ts-nocheck
import React, { memo, useCallback, useEffect, useState } from 'react'
import { array, func, number, object, string } from 'prop-types'
import styled from 'styled-components'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'

import { mq, px2rem } from '@utils'
import MultiSelect from '@reusable-modules/MultiSelect'
import Separator from '@components/Separator'
import { Icon, Container } from '@mch-group/uikit-components'

const BrowseLocations = memo(
  ({
    eventsFilters,
    locationsData,
    title,
    rows = 5,
    columns = 6,
    allLabel,
    moreLocationsLabel,
    selectedNumberLabel,
    onFilterChange
  }) => {
    const [locations, setLocations] = useState({
      all: null,
      list: null,
      menu: null
    })
    const [selectedLocations, setSelectedLocations] = useState([])

    const toggleLocation = useCallback(
      (code) => {
        const selectedLocationsCopy = [...selectedLocations]
        const querySelectedLocations = eventsFilters.cityId ? eventsFilters.cityId.split(',') : []

        if (selectedLocationsCopy.includes(code)) {
          selectedLocationsCopy.splice(selectedLocationsCopy.indexOf(code), 1)
        } else {
          selectedLocationsCopy.push(code)
        }

        setSelectedLocations(selectedLocationsCopy)

        if (querySelectedLocations.length !== selectedLocationsCopy.length) {
          const params = { cityId: selectedLocationsCopy.length ? selectedLocationsCopy.join(',') : undefined }
          onFilterChange(params)
        }
      },
      [selectedLocations, eventsFilters.cityId, onFilterChange]
    )

    useEffect(() => {
      if (locationsData) {
        const listLength = rows * columns - 2
        setLocations({
          all: locationsData,
          list: locationsData.slice(0, listLength),
          menu: locationsData
            .slice(listLength, locationsData.length)
            .sort((a, b) => a.value > b.value || (a.value < b.value ? -1 : 0))
        })
      }
    }, [locationsData, rows, columns])

    useEffect(() => {
      if (!eventsFilters.cityId) {
        setSelectedLocations([])
      } else if (eventsFilters.cityId && eventsFilters.cityId.split(',').length !== selectedLocations.length) {
        setSelectedLocations(eventsFilters.cityId.split(','))
      }
    }, [eventsFilters.cityId]) // eslint-disable-line react-hooks/exhaustive-deps

    return locations.all ? (
      <StyledWrapper>
        <h5>{title || 'Location'}</h5>
        <section>
          <StyledList
            columns={columns}
            style={{ gridTemplateRows: `repeat(${Math.min(locations.list.length || 1, rows)}, 1fr)` }}
          >
            {locations.list.map((location) => (
              <Container.Item
                as='a'
                key={location.code}
                disabled={!location.count}
                active={selectedLocations.includes(location.code)}
                onClick={() => toggleLocation(location.code)}
              >
                {location.value} {location.count ? `(${location.count})` : ''}{' '}
                {selectedLocations.includes(location.code) && <Icon name='checkmark' />}
              </Container.Item>
            ))}
            <Container.Item />
            {locations.menu && locations.menu.length > 0 && (
              <Container.Item>
                <div>
                  <MultiSelect
                    fluid
                    ariaLabel={title || 'Locations'}
                    text={moreLocationsLabel}
                    options={locations.menu}
                    itemTextKey='value'
                    itemValueKey='code'
                    onChange={(_, data) => toggleLocation(data.value[0])}
                    selected={selectedLocations}
                    disabledOptionCall={(option) => option.count === 0}
                  />
                </div>
              </Container.Item>
            )}
          </StyledList>
          <Separator isRow />
        </section>
        <MultiSelect
          fluid
          text={selectedLocations.length > 0 ? `${selectedLocations.length} ${selectedNumberLabel}` : allLabel}
          options={locations.all}
          itemTextKey='value'
          itemValueKey='code'
          onChange={(_, data) => toggleLocation(data.value[0])}
          selected={selectedLocations}
          disabledOptionCall={(option) => option.count === 0}
        />
      </StyledWrapper>
    ) : null
  }
)
BrowseLocations.displayName = 'BrowseLocations'

BrowseLocations.propTypes = {
  eventsFilters: object,
  locationsData: array,
  title: string,
  rows: number,
  columns: number,
  allLabel: string,
  moreLocationsLabel: string,
  selectedNumberLabel: string,
  onFilterChange: func
}

const StyledWrapper = styled.div`
  margin-bottom: ${px2rem(72)};
  ${mq.lessThan('desktop')`margin-bottom: 0;`};

  h5 {
    font-size: ${tokens.fontSize[1].value};
    ${mq.lessThan('desktop')`margin-bottom: 0;`};
  }

  section {
    ${mq.lessThan('desktop')`display: none;`};
  }

  > .multiple.selection.dropdown {
    display: none;
    padding: ${px2rem(10)} 0;
    border-bottom: 1px solid ${tokens.color.light.base.neutrals['300'].value};
    ${mq.lessThan('desktop')`display: block;`};
  }
`

const StyledList = styled(Container)`
  &&& {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(${(props) => props.columns}, 1fr);
    grid-gap: ${px2rem(2)};
    margin-bottom: ${px2rem(72)};

    > .item {
      padding: 0;
      height: ${px2rem(30)};
      line-height: ${tokensRenamed.lineHeights[8].value};

      &.active {
        display: flex;
        align-items: center;
        font-weight: ${tokens.fontWeights.ivarDisplay3.value};
      }
    }
  }
`

export default BrowseLocations
